<!--<as-split direction="horizontal">-->
<!--  <as-split-area [size]="60">-->
<!--    <app-vehicle-list (mySelected)="list_onSelected($event)"></app-vehicle-list>-->
<!--  </as-split-area>-->

<!--  <as-split-area [size]="40">-->
<!--    <app-vehicle-details [modelId]="selectedId$ | async"></app-vehicle-details>-->
<!--  </as-split-area>-->
<!--</as-split>-->

<kendo-splitter>
  <kendo-splitter-pane [scrollable]="false" (sizeChange)="splitter_sizeChange($event)">
    <app-vehicle-service-list (mySelected)="list_onSelected($event)"></app-vehicle-service-list>
  </kendo-splitter-pane>

  <kendo-splitter-pane size="40%" [collapsible]="true" [scrollable]="false" (sizeChange)="splitter_sizeChange($event)">
    <app-vehicle-service-details-tabs [vehicleService]="selected$ | async"></app-vehicle-service-details-tabs>
  </kendo-splitter-pane>
</kendo-splitter>
